"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * FacebookLoginButton - Uses Meta's official JavaScript SDK for authentication
 * Replaces the deprecated react-facebook-login package.
 *
 * The Meta SDK is loaded via CDN and provides the FB.login() method for authentication.
 * This component maintains the same callback interface as the original react-facebook-login,
 * so parent components can be updated with minimal changes.
 */
const FacebookLoginButton = _ref => {
  let appId = _ref.appId,
    scope = _ref.scope,
    callback = _ref.callback,
    render = _ref.render;
  const _React$useState = _react.default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    sdkReady = _React$useState2[0],
    setSdkReady = _React$useState2[1];
  (0, _react.useEffect)(() => {
    // Check if SDK is already loaded
    if (window.FB) {
      setSdkReady(true);
      return;
    }

    // Load Meta's Facebook SDK
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.onload = () => {
      // Initialize the SDK
      window.FB.init({
        appId,
        xfbml: false,
        version: 'v25.0',
        // Use same version as backend
        cookie: true,
        status: true
      });
      setSdkReady(true);
    };
    document.body.appendChild(script);
    return () => {
      // Cleanup: remove script on unmount if needed
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [appId]);
  const handleClick = () => {
    if (!window.FB) {
      console.error('Facebook SDK not loaded');
      return;
    }

    // Parse scopes (can be comma or space separated)
    const scopes = Array.isArray(scope) ? scope : scope.split(/[,\s]+/).filter(Boolean);
    window.FB.login(response => {
      var _response$authRespons, _response$authRespons2, _response$authRespons3, _response$authRespons4, _response$authRespons5;
      // Transform FB response to match react-facebook-login format
      const transformedResponse = {
        accessToken: ((_response$authRespons = response.authResponse) === null || _response$authRespons === void 0 ? void 0 : _response$authRespons.accessToken) || null,
        userID: ((_response$authRespons2 = response.authResponse) === null || _response$authRespons2 === void 0 ? void 0 : _response$authRespons2.userID) || null,
        expiresIn: ((_response$authRespons3 = response.authResponse) === null || _response$authRespons3 === void 0 ? void 0 : _response$authRespons3.expiresIn) || null,
        signedRequest: ((_response$authRespons4 = response.authResponse) === null || _response$authRespons4 === void 0 ? void 0 : _response$authRespons4.signedRequest) || null,
        graphDomain: ((_response$authRespons5 = response.authResponse) === null || _response$authRespons5 === void 0 ? void 0 : _response$authRespons5.graphDomain) || 'facebook',
        status: response.status
      };
      callback(transformedResponse);
    }, {
      scope: scopes.join(','),
      auth_type: 'rerequest'
    });
  };

  // Render prop pattern: pass handleClick as onClick to the render function
  return render && sdkReady ? render({
    onClick: handleClick
  }) : null;
};
FacebookLoginButton.propTypes = {
  appId: _propTypes.default.string.isRequired,
  scope: _propTypes.default.string,
  callback: _propTypes.default.func.isRequired,
  render: _propTypes.default.func.isRequired
};
FacebookLoginButton.defaultProps = {
  scope: 'public_profile,email'
};
var _default = exports.default = FacebookLoginButton;